import { AnyAction } from "redux";
import { SET_INTERFACE_CODE, SET_INVESTOR_CLIENTID, SET_IWAPP_RMID, SET_APPLICATION_ID, VERIFY_OTP_PAYMENT_SUCCESS, SET_FAMILY_DETAILS, SET_PAN_NUMBER, SET_IS_PORTFOLIO_AVAILABLE, SET_APPLICANT_ID, SET_APPLICATION_TYPE } from "../types/onBoarding";
import { LOGOUT_SUCCESS } from "../types/auth";
import { PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS } from "../types/cart";

export interface IdType {
    iwappRmId: string | number;
    investorClientId: string;
    clientInterfaceCode: string | null;
    applicationId?: string | number;
    applicantId?: string | number;
    familyId: string;
    familyName: string;
    isFamilyHead: string;
    panNo: string;
    isPortfolioAvailable: boolean;
    applicationType?: string;
    investorName?: string;
    status?: string;
    onboardingType?: string
}

const initState = {
    iwappRmId: '',
    investorClientId: '',
    clientInterfaceCode: '',
    applicationId: '',
    familyId: "",
    familyName: "",
    isFamilyHead: "",
    panNo: "",
    isPortfolioAvailable: false,
    applicantId: "",
    applicationType: "",
    investorName: "",
    status: "",
    onboardingType: ""
}

export default function idReducer(state = initState, action: AnyAction): Partial<IdType> {
    switch (action.type) {

        case PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS: {
            return {
                ...state,
                investorClientId: action?.body?.clientCode ?? "",
            }
        }
        case VERIFY_OTP_PAYMENT_SUCCESS: {
            return {
                ...state,
                investorClientId: action?.body?.clientCode ?? "",
            }
        }
        case SET_IWAPP_RMID: {
            // console.log("action", action);
            return {
                ...state,
                iwappRmId: action.iwappRmId
            };
        }

        case SET_INVESTOR_CLIENTID: {
            return {
                ...state,
                investorClientId: action.investorClientId
            };
        }

        case SET_INTERFACE_CODE: {
            return {
                ...state,
                clientInterfaceCode: action.clientInterfaceCode
            };
        }

        case SET_APPLICATION_ID: {
            return {
                ...state,
                applicationId: action.applicationId
            }
        }
        case SET_FAMILY_DETAILS: {
            return {
                ...state,
                familyId: action.body?.familyId ?? "",
                familyName: action.body?.familyName ?? "",
                isFamilyHead: action.body?.isFamilyHead ?? ""
            };
        }
        case SET_PAN_NUMBER: {
            return {
                ...state,
                panNo: action?.panNo ?? ""
            }
        }
        case SET_IS_PORTFOLIO_AVAILABLE: {
            return {
                ...state,
                isPortfolioAvailable: action.isPortfolioAvailable
            }
        }
        case LOGOUT_SUCCESS: {
            return initState
        }
        case SET_APPLICANT_ID: {
            return {
                ...state,
                applicantId: action.applicantId
            }
        }
        case SET_APPLICATION_TYPE: {
            return {
                ...state,
                applicationType: action.applicationType,
                investorName: action.investorName,
                status: action.status,
                onboardingType: action.onboardingType
            }
        }
        default:
            return state;
    }
}